var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResponsiveImage',{staticClass:"logo",attrs:{"image-url":_vm.imageUrl,"width":"76px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }